import { loadFileAsync } from '../../utility/attachment.encode';
import { canUseWorkers, invokeWorkerAsync } from '../../utility/workerHelper';
import { CLASSNAME_ERRMSG } from '../view/view.class.names';
import AsyncDialog from './asyncDialog';
import {
    DIALOG_RESULT_CANCEL,
    DIALOG_RESULT_RETRIEVED,
} from './dialog.constants';

const $ = window.jQuery;
const qd = window.qd;

const workerBundleHash = qd.formsViewer.workerBundleHash;

// Dialog to prompt a user to select a file
const CLASS_FILE_DIALOG = 'fv-file-dialog';
const CLASS_FILE_PICKER = 'fv-file-dialog-file';

const workerPath = '/bundles/workers.js';

// FileDialogResult is:
// {
//   result: ResultCode,
//   file: { name: String, bytes: ArrayBuffer},
//   getAttachmentBase64Async: () -> Promise[String],
// }

function makeUi() {
    return $('<div />')
        .append($('<div />').css('margin-bottom', '0.5em'))
        .append($("<input type='file' />").addClass(CLASS_FILE_PICKER))
        .append($('<br/>'))
        .append($('<div></div>').addClass(CLASSNAME_ERRMSG));
}

function FileDialog(options) {
    var target = makeUi();

    var $filePicker = target.find('input');

    this.preprocessBase64 = options && options.preprocessBase64;

    this._processFile64 = null;
    this._loadFile = null;
    this.class = CLASS_FILE_DIALOG;
    this.setTarget(target);
    this.filePicker = $filePicker[0];
    this.errorMessageDiv = target.find(`div.${CLASSNAME_ERRMSG}`)[0];
    this.buttons = [
        { text: 'OK', click: this.handleOk.bind(this) },
        { text: 'Cancel', click: this.handleCancel.bind(this) },
    ];

    $filePicker.on('change', this.onFileChange.bind(this));
}

FileDialog.prototype = Object.create(AsyncDialog.prototype);
FileDialog.prototype.filePicker = null;

FileDialog.prototype.getFileAsync = async function (file) {
    return this._loadFile || loadFileAsync(file);
};

FileDialog.prototype.setErrorMessage = function (text) {
    this.errorMessageDiv.textContent = text;
};

FileDialog.prototype.handleOk = async function () {
    var buttons = $('.' + CLASS_FILE_DIALOG).find('.ui-button');

    try {
        buttons.attr('disabled', 'disable');

        const file = this.filePicker.files[0];

        if (!file) {
            this.setErrorMessage('Please choose a file or click Cancel.');
            return;
        }

        // 2024-06-03 - Removed code with special handling for IE 9 and lower

        const result = await this.getFileAsync(file);
        this.handleFileResult(result);
    } catch (err) {
        this.setErrorMessage(`An error occurred:\n${err.message}`);
    } finally {
        buttons.removeAttr('disabled');
    }
};

FileDialog.prototype.handleFileResult = function (file) {
    if (file) {
        this.closeWithResult({
            result: DIALOG_RESULT_RETRIEVED,
            file: file,
            getAttachmentBase64Async: this.getAttachmentBase64Async.bind(this),
        });
    } else {
        console.error('An error occurred attempting to load the file.');
    }
};

FileDialog.prototype.handleCancel = function () {
    this.closeWithResult({ result: DIALOG_RESULT_CANCEL, file: null });
};

function getAttachmentFromWorker(file) {
    // need the hash to ensure that we are getting the correct (current) version of the bundle
    return invokeWorkerAsync(
        `${workerPath}?v=${workerBundleHash}`,
        { fileBytes: file.bytes, fileName: file.name },
        [file.bytes],
    );
}

// 2024-06-03 - Removed function with duplicate name of getAttachmentBase64Async

FileDialog.prototype.clearError = function () {
    this.setErrorMessage('');
};

FileDialog.prototype.onFileChange = function () {
    this.clearError();

    if (this.preprocessBase64) {
        var file = this.filePicker.files[0];

        if (file) {
            this._loadFile = loadFileAsync(file);

            if (canUseWorkers()) {
                this._processFile64 = this._loadFile.then(
                    getAttachmentFromWorker,
                );
            }
        } else {
            this._loadFile = null;
            this._processFile64 = null;
        }
    }
};

FileDialog.prototype.loadedFileAsync = async function () {
    if (this._loadFile) {
        return this._loadFile;
    }

    var file = this.filePicker.files[0];

    return file ? loadFileAsync(file) : null;
};

FileDialog.prototype.getAttachmentBase64Async = async function () {
    if (this._processFile64) {
        return await this._processFile64;
    }

    const fileData = await this.loadedFileAsync();

    return fileData && (await getAttachmentFromWorker(fileData));
};

FileDialog.prototype.constructor = FileDialog;

// Creates a FileDialog whose result, when shown, is a FileDialogResult

const createFileDialog = (options) => new FileDialog(options);

export default createFileDialog;
